import styled from 'styled-components';
import { OrderAnalysisChart } from '../../../component/chart/OrderAnalysisChart';
import { OrderAmountRankChart } from '../../../component/chart/OrderAmountRankChart';
import { OrderCountRankChart } from '../../../component/chart/OrderCountRankChart';
import { ChartByCustomerGroup } from '../../../component/chart/ChartByCustomerGroup';
import { ChartByProdAmountPrice } from '../../../component/chart/ChartByProdAmountPrice';
import { YearlyAnalysisTable } from '../../../component/table/TableComponents/YearlyAnalysisTable';

export const TableAnalysisPage = () => {
  return (
    <Container>
      <ChartTitle>월별 주문량 및 매출액 추이</ChartTitle>
      <YearlyAnalysisTable />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  * {
    box-sizing: border-box;
  }
`;

const ChartTitle = styled.h3`
  margin-bottom: 7px;
`;

const ChartContainer = styled.div`
  /* width: 80%; */
  /* flex: 1; */
  width: 65%;
  /* width: 800px; */
  height: fit-content;
  background-color: white;
  padding: 14px 18px;
`;

const FlexRowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;
